import Geocode from 'react-geocode';

// set Google Maps Geocoding API for purposes of quota management.
//Its optional but recommended.
Geocode.setApiKey(process.env.REACT_APP_G_MAP_API_KEY);

// Enable or disable logs. Its optional.
// Geocode.enableDebug();

/**
 * @memberof module:util
 * @function
 * @name getLocCoordinate
 * @description Get latitude & longitude from address.
 *
 * @param {string} address - address
 * @returns {Object}
 *
 * @example
 * console.log(getLocCoordinate("delhi, india")); //{ lat: 12.345, lng: 89.012 }
 */
export const getLocCoordinate = async (address) => {
  try {
    const res = await Geocode.fromAddress(address);
    const { lat, lng } = res.results[0].geometry.location;
    // console.log(lat, lng);
    return { lat, lng };
  } catch (err) {
    console.error(err);
    return {};
  }
};
